import * as React from 'react';

export const MinDoktor: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#mask)`}>
        <path
          d="M10.7771 3.24489C10.2197 3.23339 9.66877 3.36626 9.17786 3.6306C8.68695 3.89493 8.27275 4.28175 7.97551 4.75346C7.67966 4.28269 7.26713 3.89639 6.77796 3.63207C6.28879 3.36775 5.73959 3.23437 5.18367 3.24489C3.16571 3.28652 1.71837 5.17224 2.04653 7.16326C2.62939 10.6873 7.69878 12.6882 7.97551 12.7959C8.25224 12.6882 13.3265 10.6824 13.9045 7.16326C14.2449 5.17224 12.7878 3.28652 10.7771 3.24489Z"
          fill="#E52427"
        />
        <path
          d="M7.96571 9.88899C7.5003 9.88859 7.04206 9.77424 6.63102 9.55593C6.21919 9.3359 5.86704 9.01904 5.6049 8.63266H4.74286C5.03929 9.23444 5.49828 9.7412 6.06787 10.0956C6.63746 10.4499 7.29489 10.6378 7.96571 10.6378C8.63654 10.6378 9.29397 10.4499 9.86355 10.0956C10.4331 9.7412 10.8921 9.23444 11.1886 8.63266H10.3265C10.0644 9.01904 9.71223 9.3359 9.30041 9.55593C8.88937 9.77424 8.43113 9.88859 7.96571 9.88899Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="mask">
          <rect width="12" height="9.79592" fill="white" transform="translate(2 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};
